import React from 'react';

export const PageDescription = ({ description }) => {
  return <p className="mt-4 text-lg text-center md:text-left">{description}</p>;
};
